import { render, staticRenderFns } from "./PurchaseOrder.vue?vue&type=template&id=0a7869bc"
import script from "./PurchaseOrder.vue?vue&type=script&lang=js"
export * from "./PurchaseOrder.vue?vue&type=script&lang=js"
import style0 from "./PurchaseOrder.vue?vue&type=style&index=0&id=0a7869bc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports